module.exports = __webpack_public_path__ + "img/Picture.03d0f0e8.svg";